<template>
    <div class="form-item-column" v-for="(fieldContainer, fieldContainerKey) in fields" :key="fieldContainerKey">
        <div class="field-item" v-for="(fieldItem, fieldItemKey) in fieldContainer.filter(f=> f.isVisible != false)" :key="fieldItemKey" :class="{'duo-item': Array.isArray(fieldItem), 'checkbox': fieldItem.type == 'checkbox', 'button': fieldItem.type == 'button'}">
            <template v-if="fieldItem.type == 'button'">
                <button :disabled="fieldItem.disabled === true" v-text="fieldItem.label"></button>
            </template>
            <template v-else-if="!Array.isArray(fieldItem)">
                <label :for="`${fieldItem.label.replaceAll(' ', '').toLowerCase().replace('ú', 'u').replace('ç', 'c').replace('-', '')}${fieldItemKey}${fieldContainerKey}`" :style="`color: ${getIdealTextColor()}`">
                    <a v-if="fieldItem.link" :href="fieldItem.link" v-text="fieldItem.label" target="_blank"></a>
                    <template v-else>
                        {{ fieldItem.label }}
                        <span v-if="fieldItem.required" style="color: red">*</span>
                    </template>
                </label>
                <div :class="`field-item-input ${fieldItem.type}`" v-if="['text', 'date', 'checkbox', 'tel', 'email', 'number'].includes(fieldItem.type)">
                    <input @change="changeEvent(fieldItem)" v-if="fieldItem.mask" v-mask="fieldItem.mask" :required="fieldItem.required" :name="`${fieldItem.label.replaceAll(' ', '').toLowerCase().replace('ú', 'u').replace('ç', 'c').replace('-', '')}${fieldItemKey}${fieldContainerKey}`" :id="`${fieldItem.label.replaceAll(' ', '').toLowerCase().replace('ú', 'u').replace('ç', 'c').replace('-', '')}${fieldItemKey}${fieldContainerKey}`" :type="fieldItem.type" :placeholder="fieldItem.placeHolder" v-model="formModel[fieldItem.model]">
                    <input @change="changeEvent(fieldItem)" v-else :required="fieldItem.required" :name="`${fieldItem.label.replaceAll(' ', '').toLowerCase().replace('ú', 'u').replace('ç', 'c').replace('-', '')}${fieldItemKey}${fieldContainerKey}`" :id="`${fieldItem.label.replaceAll(' ', '').toLowerCase().replace('ú', 'u').replace('ç', 'c').replace('-', '')}${fieldItemKey}${fieldContainerKey}`" :type="fieldItem.type" :placeholder="fieldItem.placeHolder" v-model="formModel[fieldItem.model]">
                </div>
                <div class="field-item-input" v-else-if="fieldItem.type == 'dropdown'">
                    <select @change="changeEvent(fieldItem)" :required="fieldItem.required" :name="`${fieldItem.label.replaceAll(' ', '').toLowerCase().replace('ú', 'u').replace('ç', 'c').replace('-', '')}${fieldItemKey}${fieldContainerKey}`" :id="`${fieldItem.label.replaceAll(' ', '').toLowerCase().replace('ú', 'u').replace('ç', 'c').replace('-', '')}${fieldItemKey}${fieldContainerKey}`" v-model="formModel[fieldItem.model]">
                        <option value="Selecione"></option>
                        <option v-for="(fieldItemOption, fieldItemOptionKey) in fieldItem.options" :key="fieldItemOption+fieldItemOptionKey"  :value="fieldItemOption" v-text="fieldItemOption"></option>
                    </select>
                </div>
            </template>
            <template v-else-if="Array.isArray(fieldItem)">
                <div class="duo-field" v-for="(duoItem, duoItemKey) in fieldItem" :key="`${fieldItemKey}${fieldContainerKey}${duoItemKey}`">
                    <label :for="`${duoItem.label.replaceAll(' ', '').toLowerCase().replace('ú', 'u').replace('ç', 'c').replace('-', '')}${fieldItemKey}${fieldContainerKey}${duoItemKey}`" :style="`color: ${getIdealTextColor()}`" >
                        {{duoItem.label}}
                        <span v-if="duoItem.required" style="color: red">*</span>
                    </label>
                    <div :class="`field-item-input ${duoItem.type}`" v-if="['text', 'date', 'checkbox', 'tel', 'email', 'number'].includes(duoItem.type)">
                        <input @change="changeEvent(fieldItem)" :required="duoItem.required" :name="`${duoItem.label.replaceAll(' ', '').toLowerCase().replace('ú', 'u').replace('ç', 'c').replace('-', '')}${fieldItemKey}${fieldContainerKey}${duoItemKey}`" :id="`${duoItem.label.replaceAll(' ', '').toLowerCase().replace('ú', 'u').replace('ç', 'c').replace('-', '')}${fieldItemKey}${fieldContainerKey}${duoItemKey}`" :type="duoItem.type" :placeholder="duoItem.placeHolder" v-model="formModel[duoItem.model]">
                    </div>
                    <div class="field-item-input" v-else-if="duoItem.type == 'dropdown'">
                        <select @change="changeEvent(fieldItem)" :required="duoItem.required" :name="`${duoItem.label.replaceAll(' ', '').toLowerCase().replace('ú', 'u').replace('ç', 'c').replace('-', '')}${fieldItemKey}${fieldContainerKey}${duoItemKey}`" :id="`${duoItem.label.replaceAll(' ', '').toLowerCase().replace('ú', 'u').replace('ç', 'c').replace('-', '')}${fieldItemKey}${fieldContainerKey}${duoItemKey}`" v-model="formModel[duoItem.model]">
                            <option value="Selecione"></option>
                            <option v-for="(fieldItemOption, fieldItemOptionKey) in duoItem.options" :key="fieldItemOption+fieldItemOptionKey"  :value="fieldItemOption" v-text="fieldItemOption"></option>
                        </select>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { idealTextColor } from '@/controllers/libs/Util.js'
import { mask } from 'vue-the-mask'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'FormFieldList',
    props: ['fields'],
    directives: { mask },
    emits: ['changeEvent', 'newValue'],
    computed: {
        ...mapState(['formModel'])
    },
    methods: {
        ...mapActions(['updateFormModel']),
        changeEvent: function (event) {
            this.$emit('changeEvent', {
                change: event.change,
                value: event.value
            })
        },
        getIdealTextColor: function () {
            return idealTextColor()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>
